export default __webpack_public_path__ + "assets/img/image-migration-modal-mobile.png";